export default __webpack_public_path__ + "static/media/stage_06@2x.e1f5cb5a.png";